<template>
  <div
    id="payment-test-table"
    class="payment-test-table"
  >
    <b-table
      responsive
      class="table"
      :items="paymentList"
      :fields="fields"
    >
      <template
        slot="ลำดับที่"
        slot-scope="data"
      >
        <div class="col-right">
          {{ data.index + 1 }}
        </div>
      </template>
      <template
        slot="รายการ"
        slot-scope="data"
      >
        <div class="col-left">
          {{ data.item.name }}
        </div>
      </template>
      <template
        slot="จำนวนรายการ"
        slot-scope="data"
      >
        <div class="col-right">
          {{ $numeral(data.item.quantity).format('0,0') }}
        </div>
      </template>
      <template
        slot="จำนวนเงิน"
        slot-scope="data"
      >
        <div class="col-right">
          {{ $numeral(data.item.amount).format('0,0') }}
        </div>
      </template>
      <template
        slot="วันนัดชำระ"
        slot-scope="data"
      >
        <div class="col-center">
          {{ data.item.duePayment }}
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
  export default {
    name: "PaymentTestTableComponent",
    props: {
      paymentList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        fields: [
          "ลำดับที่",
          "รายการ",
          "จำนวนรายการ",
          "จำนวนเงิน",
          "วันนัดชำระ"
        ]
      };
    },
    created() {}
  };
</script>

<style lang="scss" scoped>

  .payment-test-table {
    padding-top: 2rem;
    padding-bottom: 2rem;
    .table {
      height: 200px;
      border: 1px solid black;
    }
  }
</style>
